import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './start/start.component';
import { CaseComponent } from './case/case.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { CustomersComponent } from './customers/customers.component';
// import { NewslistComponent } from './newslist/newslist.component';
// import { NewspostComponent } from './newspost/newspost.component';
import { StudiosComponent } from './studios/studios.component';
import { ErrorComponent } from './error/error.component';

export const routes: Routes = [
    {
        path: '',
        component: StartComponent,
    },
    {
        path: 'home',
        component: StartComponent,
    },
    {
        path: 'case/:slug',
        component: CaseComponent,
    },
    {
        path: 'kontakt',
        component: ContactComponent,
    },
    {
        path: 'kunder',
        component: CustomersComponent,
    },
    {
        path: 'bloomy-studios',
        component: StudiosComponent,
    },
    {
        path: 'nyheter',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'nyhet/:slug',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'om-oss',
        component: AboutComponent,
    },
    {
        path: '**',
        component: ErrorComponent,
    },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/app-routing.module.ts